package ru.arty_bikini.crm_frontend.table.production

import ru.arty_bikini.crm.dto.orders.OrderDTO
import ru.arty_bikini.crm.dto.packet.work.GetIntervalWorkResponse
import ru.arty_bikini.crm.dto.work.WorkDTO


val OrderDTO.worksTMP: List<WorkDTO>
    get() = works ?: emptyList()